<template>
  <div>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <!-- <li><router-link to="/policy">サイトのご利用について</router-link></li> -->
          <li v-if="policyList.acf?.title"><router-link to="/policy">{{ policyList.acf?.title }}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="cms">
      <div class="container">
        <div class="cms-cont">
            <h2 v-if="policyList.acf?.title && !isLoading">{{ policyList.acf?.title }}</h2>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 30px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="cms-cont__top" v-if="policyList.acf?.html_text && !isLoading" v-html="policyList.acf?.html_text"></div>
            <div class="skeleton-parent" v-if="isLoading">
              <PuSkeleton style="height: 15px; padding-bottom: 30px;" :count="25"/>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { RouterLink } from "vue-router";
import { getUrl, metaData } from '@/utils/helper';

export default {
  name: "Policy",
  components: {},
  data() {
    return {
      policyList: {},
      isLoading: true,
    };
  },
  mounted() {
    const listH2 = this.$el.querySelectorAll(".cms-cont__top h2");
    listH2.forEach((element) => {
      element.style.textAlign = "center";
    });
  },
  computed: {},
  created() {
    this.isLoading = true;
    getUrl(`/others_aboutsite/${process.env.VUE_APP_ID_POLICY}`)
    .then((response) => {
      this.policyList = response.data;

      metaData(
        `${this.policyList.acf?.title ? this.policyList.acf?.title : 'サイトのご利用について'} | HARUMIFLAGタウンポータル`,
        '中央区晴海・HARUMIFLAGのサイトのご利用についてのご案内ページです。',
        'HARUMIFLAGタウンポータル',
        'website'
      )

      this.isLoading = false;
    })
    .catch((e) => {
      console.log(e);
      this.$router.push('/timeout')
    });
  },
};
</script>